import * as Color from "../../general/Color";
import { CodeTheme } from "./CodeTheme";

/**
 * The dark mode code theme.
 */
export const DarkModeTheme: CodeTheme = {
  background: Color.DarkGrey[500],
  primary: Color.fromString("#9cdcfe"),
  comment: Color.fromString("#6a9955"),
  prolog: Color.fromString("#6a9955"),
  doctype: Color.fromString("#6a9955"),
  cdata: Color.fromString("#6a9955"),
  punctuation: Color.fromString("#ffd700"),
  namespace: Color.withAlpha(Color.fromString("#9cdcfe"), 0.7),
  property: Color.fromString("#569cd6"),
  tag: Color.fromString("#569cd6"),
  boolean: Color.fromString("#569cd6"),
  number: Color.fromString("#b5cea8"),
  constant: Color.fromString("#569cd6"),
  symbol: Color.fromString("#569cd6"),
  deleted: Color.fromString("#569cd6"),
  selector: Color.fromString("#ce9178"),
  attrName: Color.fromString("#ce9178"),
  string: Color.fromString("#ce9178"),
  char: Color.fromString("#ce9178"),
  builtIn: Color.fromString("#ce9178"),
  inserted: Color.fromString("#ce9178"),
  operator: Color.fromString("#808080"),
  entity: Color.fromString("#ffd700"),
  url: Color.fromString("#ffd700"),
  cssString: Color.fromString("#ffd700"),
  atRule: Color.fromString("#c586c0"),
  attrValue: Color.fromString("#c586c0"),
  keyword: Color.fromString("#c586c0"),
  className: Color.fromString("#ffd700"),
  function: Color.fromString("#d4d698"),
  regex: Color.fromString("#ee9900"),
  important: Color.fromString("#ee9900"),
  variable: Color.fromString("#ee9900"),
};
